// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"buildcontrols_BuildControls__1MhPY","OrderButton":"buildcontrols_OrderButton__CCG7t","enable":"buildcontrols_enable__2jW-5"};